import classnames from 'classnames';
import { omit } from 'lodash-es';
import type { PropsWithChildren } from 'react';
import type { GlobalProps } from '../types';

type NativeTableProps = React.DetailedHTMLProps<React.TableHTMLAttributes<HTMLTableElement>, HTMLTableElement>;

export type TableProps = GlobalProps & NativeTableProps;

export const Table = (props: PropsWithChildren<TableProps>) => (
  <table
    {...omit(props, 'dataQa')}
    className={classnames('w-full bg-contrast border border-light table-fixed', props.className)}
    data-qa={props.dataQa}
  >
    {props.children}
  </table>
);

type NativeTHeadProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableSectionElement>, HTMLTableSectionElement>;

export const THead = (props: PropsWithChildren<GlobalProps & NativeTHeadProps>) => (
  <thead {...omit(props, 'dataQa')} className={classnames('', props.className)}>
    {props.children}
  </thead>
);

type NativeTBodyProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableSectionElement>, HTMLTableSectionElement>;

export const TBody = (props: PropsWithChildren<NativeTBodyProps & GlobalProps>) => (
  <tbody {...omit(props, 'dataQa')} className={classnames('', props.className)}>{props.children}</tbody>
);

type NativeTRowProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableRowElement>, HTMLTableRowElement>;

export const TRow = (props: PropsWithChildren<NativeTRowProps & GlobalProps>) => (
  <tr {...omit(props, 'dataQa')} className={classnames('border-b border-light', props.className)}>{props.children}</tr>
);

type NativeTHeaderProps = React.DetailedHTMLProps<React.ThHTMLAttributes<HTMLTableHeaderCellElement>, HTMLTableHeaderCellElement>;

export type THeaderProps = NativeTHeaderProps & GlobalProps & {
  contentClassName?: string;
};

export const THeader = (props: PropsWithChildren<THeaderProps>) => {
  return (
    <th scope="col" {...omit(props, 'className', 'contentClassName')} className={classnames('sticky top-12 p-0', props.className)}>
      <div style={{ marginBottom: '-2px' }} className={classnames('flex items-center px-4 py-2 border-t border-b border-light bg-contrast align-middle text-left whitespace-nowrap', props.contentClassName)}>
        {props.children}
      </div>
    </th>
  );
};

type NativeTCellProps = React.DetailedHTMLProps<React.TdHTMLAttributes<HTMLTableDataCellElement>, HTMLTableDataCellElement>;

export const TCell = (props: PropsWithChildren<NativeTCellProps & GlobalProps>) => (
  <td {...omit(props, 'className')} className={classnames('px-4 py-4', props.className)}>{props.children}</td>
);
